import React from 'react'
import '../Aboutus/Aboutus.css'
import Projects from './Projects'
import AboutMe from './Aboutme'
import About from '../About/About'
import Video from '../Video/Video'
import Count from '../../Count/Count'
const Aboutus = () => {
  return (
    <>
    <AboutMe/>
<Video/>
<About/>
<Count/>
    </>
  )
}

export default Aboutus